import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/themes/base/datepicker.css';

const body = document.querySelector('body');
const mq_sds = "(max-width:1024px)"
const mq_ns = "(max-width:880px)"
const mq_lg = "(max-width:960px)"


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/
class Modal {
  constructor(obj) {
    this.modalOpenCN = 'is-open';
    this.bodyOpenCN = 'is-modal-open';
    this.modalCN = obj?.modalElm ?? '.js-modal';
    this.openBtnCN = obj?.modalOpenElm ?? '[data-modal-open]';
    this.modalIDattr = 'data-modal-id';
    this.modalCont = document.querySelectorAll(this.modalCN);
    this.closeBtn = document.querySelectorAll('[data-modal-close]');
    this.init();
  }

  init() {
    this.modalCont.forEach(modal => { modal.style.display = 'none'; });
    this.openModal();
    this.closeBtn.forEach(btn => {
      btn.addEventListener('click', (e) => { this.closeModal(); });
    });
  }

  openModal() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(this.openBtnCN);
      if (!btn) return;
      const modal_id = btn.getAttribute(this.modalIDattr);
      if (!modal_id) return;

      const ids = modal_id.split(',').map(id => id.trim());
      ids.forEach(id => this.openModalById(id));
    });
  }

  openModalById(id) {
    const targetModal = document.querySelector(`${this.modalCN}[${this.modalIDattr}="${id}"]`);
    if (!targetModal) return;

    document.body.classList.add(this.bodyOpenCN);
    targetModal.setAttribute('aria-hidden', 'false');
    targetModal.style.display = 'flex';
    setTimeout(() => targetModal.classList.add(this.modalOpenCN), 100);
  }

  closeModal() {
    this.modalCont.forEach(modal => {
      if (!modal.classList.contains(this.modalOpenCN)) return;

      modal.classList.remove(this.modalOpenCN);
      modal.setAttribute('aria-hidden', 'true');

      setTimeout(() => {
        modal.style.display = 'none';

        // bodyのクラスはまだ開いているモーダルがあれば残す
        const anyOpen = Array.from(this.modalCont).some(m => m.classList.contains(this.modalOpenCN));
        if (!anyOpen) document.body.classList.remove(this.bodyOpenCN);
      }, 500);
    });
  }
}


/*---------------------------------------------------------------------------------
  debounce
---------------------------------------------------------------------------------*/


const _debounce = (func, delay) => {
  let timer = 0;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(null, args), delay);
  }
}


window.onload = () => {
  scrollAnime();
};


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/


const scrollAnime = () => {
  const elems = document.querySelectorAll('.js-fadein');
  if (!elems.length) return;

  elems.forEach(elem => {
    const elRmg = elem.dataset.rmgn || '-20% 0px';
    const options = {
      root: null,
      rootMargin: `${elRmg}`,
      threshold: parseFloat(elem.dataset.threshold) || 0,
    };

    let observer;

    if(elem.hasAttribute('data-stagger')) {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          const stagger = elem.dataset.stagger || 300;
          const items =  elem.querySelectorAll('.js-fadein-stagger');
          if (entry.isIntersecting) {
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('is-show');
              }, index * stagger);
            });
            observer.unobserve(entry.target);
          }
        });
      }, options);
    } else {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-show');
            observer.unobserve(entry.target);
          }
        });
      }, options);
    }

    observer.observe(elem);
  });
};




/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const subNaiHandler = () => {
  const elms = document.querySelectorAll('.js-has-subnavi');
  const mql = window.matchMedia(mq_sds);
  let controller = new AbortController();

  const initClass = () => {
    elms.forEach(elm => {
      elm.classList.remove('is-open', 'is-hoverStyle');
    });
  };

  const toggleOpenClass = () => {
    elms.forEach(elm => {
      const btn = elm.querySelector('.js-btn');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        elm.classList.toggle('is-open');
      }, { signal: controller.signal });
    });
  };

  const handlePCTap = () => {
    elms.forEach(elm => {
      const btn = elm.querySelector('.js-btn');
      if (!btn) return;
      btn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        elm.classList.toggle('is-hoverStyle');
      }, { signal: controller.signal });
      elm.addEventListener('mouseenter', () => {
        elm.classList.add('is-hoverStyle');
      }, { signal: controller.signal });
      elm.addEventListener('mouseleave', () => {
        elm.classList.remove('is-hoverStyle');
      }, { signal: controller.signal });
    });
  };

  const listener = (event) => {
    controller.abort();
    controller = new AbortController();
    initClass();

    if (event.matches) {
      // SP処理
      toggleOpenClass();
    } else {
      // PC処理
      handlePCTap();
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
};



/*---------------------------------------------------------------------------------
  Mobile gavi
---------------------------------------------------------------------------------*/

const mobileGnavi = () => {
  const mql = window.matchMedia(mq_sds);
  const menuBtn = document.querySelector('.js-menu-btn');
  const navi = document.querySelector('.gnavi');
  const closeBtn = navi?.querySelector('.gnavi__close');
  const openClass = 'is-gnavi-open';
  let activeAction = true;
  if (!menuBtn || !navi) return;

  const handleClick = (event) => {
    event.preventDefault();
    if (activeAction) {
      body.classList.toggle(openClass);
      if (body.classList.contains(openClass)) {
        naviOpen();
      } else {
        naviClose();
      }
    }
  };

  const naviOpen = () => {
    activeAction = false;
    menuBtn.classList.add('is-show');
    body.classList.add('is-no-scroll');
    navi.style.display = 'flex';
    navi.querySelectorAll('.js-has-subnavi').forEach(elm => elm.classList.add('is-open'));
    setTimeout(function () {
      navi.classList.add('is-open');
      activeAction = true;
    }, 100);
  }

  const naviClose = () => {
    activeAction = false;
    menuBtn.classList.remove('is-show');
    body.classList.remove('is-no-scroll');
    navi.classList.remove('is-open');
    setTimeout(function () {
      navi.style.display = 'none';
      activeAction = true;
    }, 600);
  }

  const listener = (event) => {
    if (event.matches) {
      // SP用処理
      navi.style.display = 'none';
      menuBtn.removeEventListener('click', handleClick);
      menuBtn.addEventListener('click', handleClick);
      if (closeBtn) {
        closeBtn.removeEventListener('click', handleClick);
        closeBtn.addEventListener('click', handleClick);
      }
    } else {
      // PC用ブレークポイント用処理
      navi.style.display = '';
      body.classList.remove('is-no-scroll','is-gnavi-open');
      menuBtn.classList.remove('is-show');
      activeAction = true;
      menuBtn.removeEventListener('click', handleClick);
      if (closeBtn) {
        closeBtn.removeEventListener('click', handleClick);
      }
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
}



/*---------------------------------------------------------------------------------
  Accordion Box
---------------------------------------------------------------------------------*/

const accordionBox = () => {
  const accordions = document.querySelectorAll('.js-accordion');
  if (!accordions.length) return;

  accordions.forEach(pd => {
    const btn = pd.querySelector('[data-acc-trigger]');
    const box = pd.querySelector('[data-acc-body]');
    let activeAction = true;
    btn.addEventListener('click', (e) => {
      pd.classList.toggle('is-open');
    });
  });
}

/*---------------------------------------------------------------------------------
  selectbox placeholder
---------------------------------------------------------------------------------*/

const selectBoxPlaceholder = () => {
  const selectBoxes = document.querySelectorAll('select');
  if (!selectBoxes.length) return;

  selectBoxes.forEach((select) => {
    select.addEventListener("change", function () {
      this.classList.add('is-selected');
      let placeholder = this.querySelector('._placeholder');
      if (placeholder) {
        let span = document.createElement('span');
        span.classList.add('selector-placeholder-hide');
        placeholder.parentNode.insertBefore(span, placeholder);
        span.appendChild(placeholder);
      }
    });
  });
}


/*---------------------------------------------------------------------------------
  幅固定のスライダー
---------------------------------------------------------------------------------*/
const fixWidthSlide = () => {
  const slides = document.querySelectorAll('.js-fw-slide');
  if (!slides.length) return;

  slides.forEach(function(slide) {
    const itemWidth = slide.getAttribute('data-item-width') || '320px';
    const bp = Number(String(itemWidth).replace('px', '') * 1.7);
    const staticBpRaw = slide.getAttribute('data-no-slider-below');
    const staticBp = staticBpRaw ? Number(String(staticBpRaw).replace('px', '')) : null;

    let arrows;
    if(slide.querySelector('.fw-slide__mo_arrows')) {
      arrows = `,"arrows":"true"`;
    } else {
      arrows = ``;
    }

    const moOption = `{"breakpoints":{"${bp}":{"fixedWidth":false,"perPage":1,"focus":"center","gap":"10px"${arrows}}}}`;

    let autoPlayVal = true;
    let intervalVal = 4000;
    let speedVal = 500;
    let rewindVal = true;

    if(slide.dataset.autoplay === 'false') {
      autoPlayVal = false;
      rewindVal = false;
    }

    if(slide.dataset.iv) {
      intervalVal = slide.dataset.iv;
    }

    if(slide.dataset.speed) {
      speedVal = slide.dataset.speed;
    }

    slide.setAttribute('data-splide', moOption);

    const mountSplide = () => {
      const splide = new Splide( slide, {
        arrows: false,
        autoplay: autoPlayVal,
        interval: intervalVal,
        speed: speedVal,
        rewind: rewindVal,
        updateOnMove: true,
        fixedWidth: itemWidth,
        gap: '20px',
        pagination: false,
        padding: false
      });
      splide.mount();
      return splide;
    };

    if (staticBp != null) {
      // data-no-slider-below 指定時: 指定幅以下ではスライダーにせず縦並び表示
      const mqlStatic = window.matchMedia(`(max-width:${staticBp}px)`);
      let splideInstance = null;

      const listenerStatic = (event) => {
        if (event.matches) {
          if (splideInstance) {
            splideInstance.destroy();
            splideInstance = null;
          }
          slide.classList.add('is-static-stack');
        } else {
          slide.classList.remove('is-static-stack');
          if (!splideInstance) {
            splideInstance = mountSplide();
          }
        }
      };

      mqlStatic.addEventListener('change', listenerStatic);
      if (mqlStatic.matches) {
        slide.classList.add('is-static-stack');
      } else {
        splideInstance = mountSplide();
      }
      return;
    }

    const mql = window.matchMedia(`(max-width:${bp}px)`);
    const splide = mountSplide();

    const listener = (event) => {
      if (event.matches) {
        slide.classList.add('is-fw-width');
      } else {
        slide.classList.remove('is-fw-width');
      }
    };

    mql.addEventListener('change', listener);
    listener(mql);
  });
}

/*---------------------------------------------------------------------------------
  お客様からの評価スライダー
---------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-customer-voice-slider').forEach(slider => {
    const hint = slider.querySelector('.swipe-hint');
    if (!hint) return;

    let isHintVisible = false;

    // Splide初期化
    const splide = new Splide(slider, {
      type: 'slide',
      arrows: false,
      pagination: false,
      drag: 'free',
      padding: { left: '50px', right: '50px' },
      gap: 16,
      grid: {
        rows: 2,
        cols: 3,
        gap: { row: '18px', col: '16px' },
      },
      breakpoints: {
        1150: { grid: { rows: 2, cols: 2 } },
        810: {
          padding: { left: '63.5px', right: '63.5px' },
          grid: { rows: 2, cols: 1, gap: { row: '20px', col: '10px' } },
          gap: 10,
        },
      },
    });

    // ドラッグ時にヒントを非表示
    splide.on('drag', () => {
      if (!isHintVisible) return;
      hint.classList.remove('is-visible');
      hint.classList.add('is-hidden');
      isHintVisible = false;
    });

    splide.mount(window.splide.Extensions);

    // 行ごとにカードの高さを揃える
    const equalizeCardHeights = () => {
      const cards = Array.from(slider.querySelectorAll('.voice-card'));
      const cols = splide.options.grid.cols;

      for (let i = 0; i < cards.length; i += cols) {
        const rowCards = cards.slice(i, i + cols);
        let maxHeight = 0;

        // 高さリセットして scrollHeight を取得
        rowCards.forEach(card => {
          card.style.height = 'auto';
          const h = card.scrollHeight;
          if (h > maxHeight) maxHeight = h;
        });

        // 高さを揃える
        rowCards.forEach(card => (card.style.height = maxHeight + 'px'));
      }
    };

    equalizeCardHeights();

    window.addEventListener('resize', equalizeCardHeights);

    slider.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', equalizeCardHeights);
    });

    // ResizeObserverで動的テキストにも対応
    const observerResize = new ResizeObserver(equalizeCardHeights);
    slider.querySelectorAll('.voice-card').forEach(card => observerResize.observe(card));

    // スワイプヒント表示
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!isHintVisible) {
              hint.classList.add('is-visible');
              hint.classList.remove('is-hidden');
              isHintVisible = true;
            }
          } else {
            hint.classList.remove('is-visible');
            hint.classList.remove('is-hidden');
            isHintVisible = false;
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(slider);
  });
});


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------
  youtube埋め込みモーダル
---------------------------------------------------------------------------------*/
const youtubeLazyModal = () => {
  const embedVideos = document.querySelectorAll('.js-modal-video');
  if (!embedVideos.length) return;

  embedVideos.forEach((video) => {
    const iframe = video.querySelector('iframe');
    if (!iframe) return;

    const videoThumb = video.querySelector('.js-modal-video__thumb');
    const videoBody = video.querySelector('.js-modal-video__body');
    const url = iframe.getAttribute('data-src');
    const thumb = iframe.getAttribute('data-thumb');
    if (!url) return;

    const title = iframe.getAttribute('title');
    const idMatch = url.match(/[\/?=]([a-zA-Z0-9_-]{11})[&\?]?/);
    if (!idMatch) return;
    const id = idMatch[1];
    
    document.body.appendChild(videoBody.parentElement);

    let thumbCode = `
      <img src="${thumb || `https://img.youtube.com/vi/${id}/maxresdefault.jpg`}" alt="${title}" width="1280" height="720" />
      <div class="play-btn"></div>
    `;
    videoThumb.insertAdjacentHTML('afterbegin', thumbCode);
    iframe.remove();

    videoThumb.addEventListener('click', function () {
      if (!videoBody.querySelector('.loded-video')) {
        videoBody.innerHTML = `
        <div class="loded-video">
          <iframe
            src="https://www.youtube.com/embed/${id}?enablejsapi=1"
            title="${title}"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
        `;
      } else {
        return;
      }
    });

    const modalClose = video.querySelectorAll('[data-modal-close]');
    modalClose.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const videoWindow = video.querySelector('.loded-video iframe').contentWindow;
        const iframeController = function(action,arg=null){
          videoWindow.postMessage('{"event":"command", "func":"'+action+'", "args":'+arg+'}', '*');
        };
        iframeController('pauseVideo');
      });
    });
  });
}


/*---------------------------------------------------------------------------------
  ツールチップ
---------------------------------------------------------------------------------*/

const toolTips = () => {
  let group = document.querySelectorAll('.tooltip-group');
  if (!group.length) return;

  const tooltip = () => {
    group = document.querySelectorAll('.tooltip-group');
    let viewportWidth = window.innerWidth;

    group.forEach(gp => {
      const trigger = gp.querySelector('.tooltip-trigger');
      let tooltip = gp.querySelector('.tooltip');
      const ttCloseBtn = gp.querySelector('.tooltip-close');
      let activeAction = true;

      let tooltipRect = tooltip.getBoundingClientRect();
      let left = tooltipRect.left;
      let right = tooltipRect.right;
      const gap = 15;

      tooltip.style = '';
      /* 左端がはみ出した場合 */
      if(left < 0) {
        tooltip.style.setProperty('--_tx', `${left - gap}px`);
      }
      /* 右端がはみ出した場合 */
      if(right > viewportWidth) {
        tooltip.style.setProperty('--_tx', `${right - viewportWidth + gap}px`);
      }

      const ttOpen = () => {
        activeAction = false;
        tooltip.classList.add('is-tap');
        setTimeout(function () {
          activeAction = true;
        }, 100);
      }

      const ttClose = () => {
        activeAction = false;
        tooltip.classList.remove('is-tap');
        setTimeout(function () {
          activeAction = true;
        }, 100);
      }

      ttCloseBtn.addEventListener('touchstart', (event) => {
        ttClose();
      });


      trigger.addEventListener('touchstart', (event) => {
        event.preventDefault();
        if (activeAction) {
          tooltip.classList.toggle('is-tap');
          if (tooltip.classList.contains('is-tap')) {
            ttOpen();
          } else {
            ttClose();
          }
        }
      });
    });
  }

  const debouncedTT = _debounce(tooltip, 300);
  tooltip()

  const mql = window.matchMedia(mq_ns);

  const listener = (event) => {
    if (event.matches) {
      // SP処理
      window.addEventListener('resize', debouncedTT);
    } else {
      document.querySelectorAll('.tooltip').style = '';
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
}


/*---------------------------------------------------------------------------------
  寺院詳細ページ　画像スライダー
---------------------------------------------------------------------------------*/

const tmpDtlImageSlide = () => {

  const dtlSlide = document.querySelector('.detail-slide');
  if (!dtlSlide) return;

  let controller = new AbortController();

  const mainSlide = dtlSlide.querySelector('.main-slide');
  const slideNavi = dtlSlide.querySelector('.slide-navi');

  const container = document.querySelector('.detail-slide .thumbnails'); // wrapするの要素を取得
  const siteFrameMain = document.querySelector('.site-wrapper main');
  const slides = mainSlide.querySelectorAll('.splide__slide');

  //サムネイルリストの作成
  const createThumbList = () => {
    const imagesPerList = 12; // 1つの wrap に入れる画像数
    let wrap;

    slides.forEach((slide, index) => {
      if (index % imagesPerList === 0) {
        wrap = document.createElement('div');
        wrap.classList.add('splide__slide','wrap');
        container.appendChild(wrap);
      }

      const item = document.createElement('figure');
      item.classList.add('thumbnail');

      // 動画
      if (slide.dataset.type === 'movie') {
        const movieId = slide.dataset.movieId;
        if (movieId) {
          const img = document.createElement('img');
          img.src = `https://img.youtube.com/vi/${movieId}/mqdefault.jpg`;
          item.appendChild(img);
        }

      // 画像
      } else {
        const img = slide.querySelector('img');
        if (img) {
          item.appendChild(img.cloneNode(true));
        }
      }

      wrap.appendChild(item);
    });
  }

  const createMobileThumbList = () => {
    slides.forEach((slide) => {
      const item = document.createElement('figure');
      item.classList.add('splide__slide','thumbnail');

      // 動画
      if (slide.dataset.type === 'movie') {
        const movieId = slide.dataset.movieId;
        if (movieId) {
          const img = document.createElement('img');
          img.src = `https://img.youtube.com/vi/${movieId}/mqdefault.jpg`;
          item.appendChild(img);
        }

      // 画像
      } else {
        const img = slide.querySelector('img');
        if (img) {
          item.appendChild(img.cloneNode(true));
        }
      }

      container.appendChild(item);
    });
  }

  const delThumbList = () => {
    container.innerHTML = '';
  }

  const thumbClickInterloc = () => {
    const thumbnails = document.querySelectorAll('.slide-navi .thumbnail');
    let current;

    for (var i = 0; i < thumbnails.length; i++ ) {
      initThumbnail( thumbnails[ i ], i );
    }

    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        main.go(index);
      }, { signal: controller.signal });
    }

    main.on('mounted move', function () {
      const thumbnail = thumbnails[main.index];
      if (thumbnail) {
        if (current) {
          current.classList.remove('is-active');
        }
        thumbnail.classList.add('is-active');
        current = thumbnail;
      }
    });
  }

  const main = new Splide( mainSlide, {
    type: 'fade',
    rewind: true,
    pagination: false,
  });

  const slidenavi = new Splide( slideNavi, {
    rewind: true,
    pagination: false,
    gap: '1rem'
  });

  const slidenaviMo = new Splide( slideNavi, {
    type: 'loop',
    rewind: true,
    pagination: false,
    arrows: false,
    isNavigation: true,
    perPage: 3,
    perMove: 1,
    padding: '10%',
    gap: '10px'
  });


  let lastWidth = siteFrameMain.offsetWidth; // 初期幅を記録
  let lastHeight = siteFrameMain.offsetHeight; // 初期幅を記録
  let isInitialized = false;
  let stdHeight;

  let slideHeight = dtlSlide.offsetHeight;

  const mountFunc = (width) => {
    setTimeout(() => {
      stdHeight = mainSlide.querySelector('img').offsetHeight;
      dtlSlide.style.setProperty('--_msi-h', stdHeight + 'px');
    }, '50');

    if (width <= 900) {
      delThumbList();
      createMobileThumbList();
      main.sync(slidenaviMo);
      main.mount();
      slidenaviMo.mount();
    } else {
      delThumbList();
      createThumbList();
      thumbClickInterloc();
      main.mount();
      slidenavi.mount();

      const naviArrowEl = dtlSlide.querySelector('.slide-navi__arrow');
      if (naviArrowEl) {
        const wrapCount = container.querySelectorAll('.wrap').length;
        naviArrowEl.classList.toggle('is-arrows-hidden', wrapCount <= 1);
      }
    }
  };

  //初回実行 (ページロード時にも処理を適用)
  mountFunc(lastWidth);

  const resizeHandler = _debounce((width) => {
    mountFunc(width);
  }, 300);

  const resizeObserver = new ResizeObserver(([entry]) => {
    if (!isInitialized) {
      isInitialized = true; // 初回はスキップ
      return;
    }

    const { width, height } = entry.contentRect;

    if (width !== lastWidth) {
      controller.abort();
      controller = new AbortController();
      main.destroy();
      slidenavi.destroy();
      slidenaviMo.destroy();
      resizeHandler(width);
    }

    lastWidth = width;
    lastHeight = height;
    slideHeight = dtlSlide.offsetHeight;
  });

  resizeObserver.observe(siteFrameMain);
}


/*---------------------------------------------------------------------------------
  資料の一括請求ボタン  s-recsInfos
---------------------------------------------------------------------------------*/


const recsInfos = () => {
  const btns = document.querySelectorAll('.js-recsInfos');
  const countEls = document.querySelectorAll('.js-check-count');
  const clearBtn = document.querySelector('.js-clear-selection');
  const primaryCheckboxes = document.querySelectorAll('.temple-card input[name="temple_id[]"]');
  const allCheckboxes = document.querySelectorAll('.temple-card input[type="checkbox"]');
  const masterCheck = document.querySelector('.master-check');

  if (!btns.length) return;

  let checkedIds = [];

  const getCardCheckboxes = (card) => card.querySelectorAll('input[type="checkbox"]');

  const initUI = () => {
    allCheckboxes.forEach(cb => cb.classList.add('is-visible'));
    countEls.forEach(el => el.classList.add('is-visible'));
    updateUI();
  };

  const updateUI = () => {
    btns.forEach(btn => btn.disabled = checkedIds.length === 0);
    countEls.forEach(el => {
      el.textContent = checkedIds.length;
    });

    primaryCheckboxes.forEach((primaryCb) => {
      const card = primaryCb.closest('.temple-card');
      if (!card) return;
      const isChecked = checkedIds.includes(primaryCb.value);
      getCardCheckboxes(card).forEach((cb) => {
        cb.checked = isChecked;
      });
    });

    if (masterCheck) {
      masterCheck.checked = primaryCheckboxes.length > 0 && checkedIds.length === primaryCheckboxes.length;
    }
  };

  allCheckboxes.forEach((cb) => {
    cb.addEventListener('change', () => {
      const card = cb.closest('.temple-card');
      if (!card) return;
      const primaryCb = card.querySelector('input[name="temple_id[]"]');
      if (!primaryCb) return;
      const id = primaryCb.value;
      if (cb.checked) {
        if (!checkedIds.includes(id)) checkedIds.push(id);
      } else {
        checkedIds = checkedIds.filter((v) => v !== id);
      }
      updateUI();
    });
  });

  document.querySelectorAll('.js-temple-bulk-request-btn').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const card = btn.closest('.temple-card');
      if (!card) return;
      const primaryCb = card.querySelector('input[name="temple_id[]"]');
      if (!primaryCb) return;
      primaryCb.checked = !primaryCb.checked;
      primaryCb.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  if (masterCheck) {
    masterCheck.addEventListener('change', () => {
      if (masterCheck.checked) {
        primaryCheckboxes.forEach((cb) => {
          if (!checkedIds.includes(cb.value)) checkedIds.push(cb.value);
        });
      } else {
        checkedIds = [];
      }
      updateUI();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      checkedIds = [];
      updateUI();
    });
  }

  initUI();
};

/*---------------------------------------------------------------------------------
  フォームの個人情報の取扱いに同意 チェックボックス
---------------------------------------------------------------------------------*/

const privacyAgree = () => {
  const privCheck = document.querySelector('#js-priv-check');
  if (!privCheck) return;

  const privSubmit = document.querySelectorAll('.js-priv-submit');

  privCheck.addEventListener('change', function () {
    if (this.checked) {
      privSubmit.forEach(function (element) {
        element.disabled = false;
      });
    } else {
      privSubmit.forEach(function (element) {
        element.disabled = true;
      });
    }
  });
}


/*---------------------------------------------------------------------------------
  table of contents - 記事ページ目次を作成
---------------------------------------------------------------------------------*/

const tableOfContents = () => {
  const toc = document.querySelector('.js-toc');
  if (!toc) return;
  const entryBody = document.querySelector('.entry-body');
  // const heads = entryBody.querySelectorAll('h2, h3');
  const heads = document.querySelectorAll('.entry-body > h2,.entry-body > h3, .entry-body > * > h2, .entry-body > * > h3');

  if (!heads.length) {
    toc.style.display = 'none';
    return;
  }

  let contents = '';
  heads.forEach((head, i) => {
    let className = '';
    switch(head.localName) {
      case "h2":
        className = `hlv-2`;
        break;
      case "h3":
        className = `hlv-3`;
        break;
    }

    // 記事中のヘディングタグに ID を設定
    const headingId = `head${i + 1}`;
    head.id = headingId;

    // 目次リンクの作成
    contents += `<li class="toc-list__item ${className}"><a href="#heading${i + 1}">${head.textContent}</a></li>`;
    head.innerHTML += `<a id="heading${i + 1}"></a>`;
  })
  document.querySelector('.toc-content').innerHTML += `<ol class='toc-list'>${contents}</ol>`;
}


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/
const condChangeBtn = () => {
  const openBtn = document.querySelector('.cond-chg-btn.js-condChange');
  if (!openBtn) return;

  const panel = document.querySelector('.results-search');
  if (!panel) return;

  const closeBtn = panel.querySelector('.ccb-close');
  if (!closeBtn) return;

  const mql = window.matchMedia(mq_sds);

  const panelOpen = () => panel.classList.add('is-open');
  const panelClose = () => panel.classList.remove('is-open');

  openBtn.addEventListener('click', () => panelOpen());
  closeBtn.addEventListener('click', () => panelClose());

  mql.addEventListener('change', (event) => { if (!event.matches) panelClose(); });
  if (!mql.matches) panelClose();
};

document.addEventListener('DOMContentLoaded', () => {
  const modal = new Modal();
  condChangeBtn();

  // 通常の「お墓を探す」ボタン
  const mainSearchBtns = document.querySelectorAll('.js-condChange:not(.js-gnavi):not(.cond-chg-btn)');
  mainSearchBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.openModalById('area-prefectures');
    });
  });
  
  // グローバルナビ用ボタン（SPのみ）
  const gnaviLis = document.querySelectorAll('.js-gnavi.js-condChange');
  gnaviLis.forEach(gnaviLi => {
    gnaviLi.addEventListener('click', (e) => {
      if (mq_ns.match) {
        e.preventDefault();
        modal.openModalById('area-prefectures');
      }
    }, { capture: true });
  });

  // 条件変更ボタン（都道府県モーダルは開かない）
  const condBtns = document.querySelectorAll('.cond-chg-btn.js-condChange');
  condBtns.forEach(condBtn => {
    condBtn.addEventListener('click', () => {
      const resultsPanel = document.querySelector('.results-search');
      if (resultsPanel) {
        resultsPanel.classList.add('is-open');
      }
    });
  });
});



/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const checkboxBind = (rangeSelector, displaySelector, btnSelector) => {
  const range = document.querySelector(rangeSelector);
  const display = document.querySelector(displaySelector);

  if (!range || !display) return;

  const btnSel = btnSelector || '.label-btn';

  const checkboxes = range.querySelectorAll(`${btnSel} input[type="checkbox"]`);

  const applySelections = () => {
    const checkedInputs = Array.from(checkboxes).filter(input => input.checked);

    display.innerHTML = checkedInputs
      .map(input => {
        const labelBtn = input.closest(btnSel);
        const textElement = labelBtn.querySelector('._text');
        return textElement ? `<span>${textElement.textContent.trim()}</span>` : '';
      })
      .join('');

    display.parentNode
      .querySelectorAll('input[type="hidden"]')
      .forEach(el => el.remove());

    const hiddenHTML = checkedInputs
      .map(input => `<input type="hidden" name="${input.name}" value="${input.value}">`)
      .join('');
    display.insertAdjacentHTML('afterend', hiddenHTML);
  };

  const submitBtn = range.querySelector('[data-apply-conditions]');

  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      applySelections();
      const closeBtn = range.querySelector('[data-modal-close]');
      closeBtn?.click();
    });
  }
};


const radioBind = (rangeSelector, displaySelector, btnSelector) => {
  const range = document.querySelector(rangeSelector);
  const display = document.querySelector(displaySelector);

  if (!range || !display) return;

  const btnSel = btnSelector || '.label-btn';

  const radios = range.querySelectorAll(`${btnSel} input[type="radio"]`);

  const updateDisplay = () => {
    const checkedRadio = Array.from(radios).find(input => input.checked);

    if (checkedRadio) {
      const label = checkedRadio.closest(btnSel);
      const textEl = label?.querySelector('._text');
      display.innerHTML = textEl ? `<span>${textEl.textContent.trim()}</span>` : '';
    } else {
      display.innerHTML = '';
    }
  };

  radios.forEach(rb => rb.addEventListener('change', updateDisplay));
  // updateDisplay();
};

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function(){
  subNaiHandler()
  mobileGnavi()
  fixWidthSlide()
  youtubeLazyModal()
  toolTips()
  tmpDtlImageSlide()
  recsInfos()
  privacyAgree()
  tableOfContents()
  condChangeBtn()
  const modals = new Modal()
  selectBoxPlaceholder()
  accordionBox()

  radioBind('.area-pref-modal','.area-pref-value','.pref-btn')
  checkboxBind('.area-muni-modal','.area-muni-value','.condition-item')
  checkboxBind('.conditions-modal','.conditions-value','.condition-item')
})


$(function () {
  /**
   * 同意ボタンの非活性化
   */
  const disabledCheckElement = $('[data-submit-disabled-check-trigger]')
  const disabledSubmitElement = $('[data-submit-disabled]')
  if (disabledCheckElement.length && disabledSubmitElement.length) {
    disabledCheckElement.on('change', function () {
      if ($(this).prop('checked')) {
        disabledSubmitElement.attr('data-submit-disabled', '')
        disabledSubmitElement.find('input, button').prop('disabled', false)
      } else {
        disabledSubmitElement.attr('data-submit-disabled', 'disabled')
        disabledSubmitElement.find('input, button').prop('disabled', true)
      }
    })
  }


  /**
   * Cookieからトラッキングパラメータを取得し、フォーム値に反映する
   */
  const trackingParams = {
    utm_campaign: null,
    utm_source: null,
    utm_medium: null,
    utm_content: null,
    utm_term: null,
    gclid: null,
    gad_source: null,
    gad_campaignid: null
  }
  const cookieLists = document.cookie
  if (cookieLists) {
    const cookies = cookieLists.split(';')
    cookies.forEach(function (cookieVal) {
      const vals = cookieVal.split('=')
      const cookieName = vals[0].replace(/ /, '')
      const cookieValue = vals[1]
      Object.keys(trackingParams).forEach(function (key) {
        if (key === cookieName) {
          trackingParams[key] = cookieValue
        }
      })
    })
  }
  Object.keys(trackingParams).forEach(function (key) {
    if (trackingParams[key]) {
      $(`[name="${key}"]`).val(trackingParams[key])
    }
  })


  /**
   * submit前にpayloadの調整をする
   * トリガーはtype="button"にすること
   */
  $('[data-change-param]').on('click', function () {
    if ($('input[data-checkbox="grave_type"]').length) {
      $('[name="grave_type"]').val('')
      if ($('input[data-checkbox="grave_type"]:checked').length) {
        $('[name="grave_type"]').val($('input[data-checkbox="grave_type"]:checked').map(function () {
          return $(this).val()
        })
          .get()
          .join(','))
      }
    }
    if ($('input[data-checkbox="temple"]').length) {
      $('[name="temple"]').val('')
      if ($('input[data-checkbox="temple"]:checked').length) {
        $('[name="temple"]').val($('input[data-checkbox="temple"]:checked').map(function () {
          return $(this).val()
        })
          .get()
          .join(','))
      }
    }
    $('[data-request-form]').submit()
  })


  /**
   * フォームバリデーション
   */
  $('form[data-request-form]').submit(function (e) {
    let isSubmitReady = true
    let firstErrorElement = null
    const _self = $(this)
    _self.find('[data-required-error]').hide()
    _self.find('[data-kana-error]').hide()
    _self.find('[data-email-error]').hide()
    _self.find('[data-tel-error]').hide()
    _self.find('[data-validation]').map(function () {
      const inputName = $(this).data('validation-name') === undefined ? $(this).attr('name') : $(this).data('validation-name')
      const validationTypeLists = $(this).data('validation').split(',')
      const isRequired = !!validationTypeLists.find(type => type === 'required')
      const isKana = !!validationTypeLists.find(type => type === 'kana')
      const isEmail = !!validationTypeLists.find(type => type === 'email')
      const isTel = !!validationTypeLists.find(type => type === 'tel')
      const isHasBone = !!validationTypeLists.find(type => type === 'has_bone')
      if (isRequired) {
        if ($(this).data('validation-name') === undefined) {
          if (!$(this).val()) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-required-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        } else {
          if (!$(this).find(`[name^="${inputName}"]:checked`).length) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-required-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = errorElement.length ? errorElement : $(this)
            }
          }
        }
      }
      if (isKana) {
        if ($(this).val()) {
          if (!$(this).val().match(/^[ァ-ヶー　]+$/)) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-kana-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        }
      }
      if (isEmail) {
        if ($(this).val()) {
          if (!$(this).val().match(/.+@.+\..+/)) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-email-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        }
      }
      if (isTel) {
        if ($(this).val()) {
          if (!$(this).val().match(/^0\d{9,10}$/)) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-tel-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        }
      }
      if (isHasBone) {
        const hasBoneField = _self.find('input[name="has_bone"]');
        if (hasBoneField.length > 0) {
          const hasBone = hasBoneField.filter(':checked').val();
          if (!hasBone) {
            isSubmitReady = false;
            const errorElement = _self.find(`[data-required-error="has_bone"]`)
            errorElement.show();
            if (!firstErrorElement) {
              firstErrorElement = hasBoneField.first()
            }
          }
        }
      }
    })
    if (!isSubmitReady) {
      if (firstErrorElement && firstErrorElement.length) {
        let scrollTarget = null
        if (firstErrorElement.is('[data-required-error], [data-kana-error], [data-email-error], [data-tel-error]')) {
          scrollTarget = firstErrorElement.closest('.form-field')
        } else if (firstErrorElement.is('input[type="hidden"]')) {
          const inputName = firstErrorElement.data('validation-name') || firstErrorElement.attr('name')
          const errorElement = _self.find(`[data-required-error="${inputName}"]`)
          if (errorElement.length) {
            scrollTarget = errorElement.closest('.form-field')
          } else {
            scrollTarget = firstErrorElement.closest('.form-field')
          }
        } else {
          scrollTarget = firstErrorElement.closest('.form-field').length 
            ? firstErrorElement.closest('.form-field') 
            : firstErrorElement
        }
        
        if (scrollTarget && scrollTarget.length) {
          const offsetTop = scrollTarget.offset().top - 180
          $('html, body').animate({
            scrollTop: offsetTop
          }, 400)
          if (firstErrorElement.is('input:not([type="hidden"]), select, textarea')) {
            firstErrorElement.focus()
          }
        }
      }
      return false
    }
    // 多重送信防止: バリデーション通過後にボタンを非活性化してローディング表示
    _self.find('[data-change-param]').prop('disabled', true)
    // オーバーレイを body に直接追加（親要素の overflow/transform の影響を回避）
    $('body').addClass('is-no-scroll').append(
      '<div class="form-loading-overlay is-active" id="js-form-loading" aria-hidden="false">' +
        '<div class="form-loading-overlay__inner">' +
          '<span class="form-loading-overlay__spinner" aria-hidden="true"></span>' +
          '<p class="form-loading-overlay__text">ただいま、送信中です</p>' +
        '</div>' +
      '</div>'
    )
  })

  /**
   * 必須項目：入力があったら赤背景用クラス(_required)を外す
   */
  $(document).on('input change', '[data-request-form] .form-field__input._required, [data-request-form] .form-field__select._required, [data-request-form] .form-choice__input._required', function () {
    const $el = $(this)
    const tagName = this.tagName.toLowerCase()
    const type = (this.type || '').toLowerCase()
    let hasValue = false
    if (type === 'checkbox' || type === 'radio') {
      if (type === 'radio') {
        hasValue = $el.closest('form').find(`input[name="${this.name}"]:checked`).length > 0
        const $group = $el.closest('form').find(`input[name="${this.name}"]`)
        if (hasValue) {
          $group.removeClass('_required')
        } else {
          $group.addClass('_required')
        }
      } else {
        hasValue = this.checked
        if (hasValue) $el.removeClass('_required')
        else $el.addClass('_required')
      }
    } else {
      hasValue = $el.val() != null && String($el.val()).trim() !== ''
      if (hasValue) {
        $el.removeClass('_required')
      } else {
        $el.addClass('_required')
      }
    }
  })

})


/**
 * 動的にpath切り替え処理
 */
const calenderRequestPath = document.querySelector('[data-form-path]');

if (calenderRequestPath) {
  const url = 'https://www2.eitaikuyou.net';
  const path = calenderRequestPath.dataset.formPath;
  const requestUrl = url + path;

  const calenderRequestButton = document.querySelector('[data-change-param]');
  if (calenderRequestButton) {
    calenderRequestButton.addEventListener('click', function(event) {
      if (calenderRequestPath.checkValidity()) {
        calenderRequestPath.action = requestUrl;
      } else {
        event.preventDefault();
        calenderRequestPath.reportValidity();
      }
    });
  }
}

/**
 * フォーム送信時にsuccesslocationに値を含める
 */
document.addEventListener('DOMContentLoaded', () => {
  const fieldsToSave = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
  fieldsToSave.forEach(fieldName => {
    const inputField = document.querySelector(`input[name="${fieldName}"]`);
    if (inputField) {
      inputField.addEventListener('input', (event) => {
        const fieldValue = event.target.value;
        setCookie(fieldName, fieldValue, 1);
      });
    }
  });

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const path = window.location.pathname;
  if (path.startsWith('/document-request/complete')) {
    setFormData();
  }
  function setFormData() {
    function getCookie(name) {
      let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    const fields = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
    fields.forEach(field => {
      const value = getCookie(field);
      if (value) document.querySelector(`input[name="${field}"]`).value = value;
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  function deleteCookie(name) {
    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
  }
  function deleteFormCookies() {
    const fields = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
    fields.forEach(field => {
      deleteCookie(field);
    });
  }
  const button = document.querySelector('.submit.calendar-submit[data-change-param]');
  if (button && window.location.pathname.endsWith('/document-request/complete')) {
    button.addEventListener('click', deleteFormCookies);
  }
});


/**
 * カレンダー表示
 */
$(document).ready(function() {
  let $tourDateDisplay = $("#tour_date_display");
  let $hiddenTourDate = $("#tour_date");
  let $datepickerContainer = $("#datepicker-container")[0];

  // 3ヶ月後の末日を計算する関数
  const today = new Date();
  today.setHours(0, 0, 0, 0); // 時間をリセットして、日付のみで比較できるようにする
  function getLastDateOfThreeMonthsLater() {
    return new Date(today.getFullYear(), today.getMonth() + 4, 0);
  }

  // 日付と曜日を組み合わせたフォーマットを作成する関数（送信用）
  function createDateFormat(dateText){
    const date = new Date(dateText);
    const daysOfWeek = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
    return dateText + ',' + daysOfWeek[date.getDay()];
  }

  // force_holidays + temple_week による休業日判定
  function isCheckHolidays(date){
    if (window.forceHolidaysData && window.forceHolidaysData.length > 0) {
      const dateStr = $.datepicker.formatDate('y-mm-dd', date);
      for (let i = 0; i < window.forceHolidaysData.length; i++) {
        const forceHoliday = window.forceHolidaysData[i];
        if (forceHoliday.date === dateStr) return !forceHoliday.is_working;
      }
    }
    if (window.templeWeekData && Object.keys(window.templeWeekData).length > 0) {
      const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      const dayKey = weekdays[date.getDay()];
      if(window.templeWeekData[dayKey]!==undefined) return !window.templeWeekData[dayKey];
    }
    return false;
  }

  // 日付範囲のオプションを生成し、<select>に追加
  function populateDateSelect() {
    const maxDate = getLastDateOfThreeMonthsLater();
    let currentDate = new Date(today);

    while (currentDate <= maxDate) {
      if (isCheckHolidays(currentDate)) {
        currentDate.setDate(currentDate.getDate() + 1);
        continue;
      }

      const optionText = $.datepicker.formatDate('yy-mm-dd', currentDate);
      const displayText = `${currentDate.getFullYear()}年${currentDate.getMonth()+1}月${currentDate.getDate()}日`;
      $tourDateDisplay.append($("<option>").val(optionText).text(displayText));
      currentDate.setDate(currentDate.getDate() + 1); // 次の日付に移動
    }
    $tourDateDisplay.val($.datepicker.formatDate('yy-mm-dd', today)).change();
  }

  populateDateSelect(); // ページ読み込み時に <select> に日付オプションを追加

  if($tourDateDisplay.val()){
    $hiddenTourDate.val(createDateFormat($tourDateDisplay.val()));
  }

  // <select> の変更イベントで hidden フィールド及びカレンダーの高さを更新
  $tourDateDisplay.on('change', function() {
    const dateText = $(this).val();
    $hiddenTourDate.val(createDateFormat(dateText));
    $("#datepicker-container").datepicker("setDate", dateText);
    renderSixRows(dateText);
  });

  // 6行固定描画
  function renderSixRows(selectedDate){
    const $dp = $("#datepicker-container");
    const inst = $dp.data("datepicker");
    if(!inst) return;

    const drawYear = inst.drawYear;
    const drawMonth = inst.drawMonth;
    const firstOfMonth = new Date(drawYear, drawMonth,1);
    const startDate = new Date(firstOfMonth);
    startDate.setDate(startDate.getDate() - startDate.getDay());

    const $tbody = $dp.find(".ui-datepicker-calendar tbody");
    $tbody.empty();

    let currentDate = new Date(startDate);
    for(let row=0; row<6; row++){
      const $tr = $("<tr></tr>");
      for(let col=0; col<7; col++){
        const ymd = $.datepicker.formatDate('yy-mm-dd', currentDate);
        const result = $dp.datepicker("option","beforeShowDay")(currentDate);
        const isSelectable = result[0];
        const className = result[1] + (currentDate.getMonth()!==drawMonth?' ui-datepicker-other-month':'');

        const $td = $("<td></td>").addClass(className);
        if(isSelectable){
          const $a = $("<a></a>").addClass("ui-state-default").text(currentDate.getDate()).attr("data-date", ymd);
          if(selectedDate && ymd===selectedDate) $a.addClass("ui-state-active");
          $td.append($a);
        } else {
          $td.append($("<span></span>").addClass("ui-state-default").text(currentDate.getDate()));
        }
        $tr.append($td);
        currentDate.setDate(currentDate.getDate()+1);
      }
      $tbody.append($tr);
    }
  }

  $.get("https://holidays-jp.github.io/api/v1/date.json", function(holidaysData) {
    $("#datepicker-container").datepicker({
      showOtherMonths:true,
      selectOtherMonths:true,
      beforeShowDay: function(date) {
        const ymd = $.datepicker.formatDate('yy-mm-dd', date);
        let isSelectable = true;
        let className = '';

        if (date < today) {
          className = 'past-date';
        } else if (isCheckHolidays(date)) {
          className = ' holidays';
          isSelectable = false;
        }
        else{
          className = 'future-date';
        }

        // 曜日や祝日条件を追加で判定
        if (date.getDay() === 0) {
          className = className + ' ' + 'day-sunday';
        } else if (date.getDay() === 6) {
          className = className + ' ' + 'day-saturday';
        } else if (holidaysData[ymd]) {
          className = className + ' ' + 'day-holiday';
        } else{
          className = className + ' ' + 'day-weekday';
        }

        return [isSelectable, className, null];
      },
      dateFormat: 'yy-mm-dd',
      minDate: 0,
      maxDate: getLastDateOfThreeMonthsLater(),
      onSelect: function(dateText) {
        $tourDateDisplay.val(dateText).change();
      },
      beforeShow:function(){ setTimeout(()=>renderSixRows($tourDateDisplay.val()),0); },
      onChangeMonthYear:function(){ setTimeout(()=>renderSixRows($tourDateDisplay.val()),0); },
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      dayNames: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
      dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
      showMonthAfterYear: true,
      yearSuffix: '年',
      prevText: '',
      nextText: '',
      showButtonPanel: false
    });

    // 初期表示も6行描画
    setTimeout(()=>renderSixRows($tourDateDisplay.val()),100);
  });

  // 日付クリックハンドラ（セレクトボックス同期）
  $("#datepicker-container").on("click","a.ui-state-default",function(){
    const dateText = $(this).attr("data-date");

    if($("#tour_date_display option[value='"+dateText+"']").length===0){
      const d = new Date(dateText);
      const displayText = `${d.getFullYear()}年${d.getMonth()+1}月${d.getDate()}日`;
      $tourDateDisplay.append($("<option>").val(dateText).text(displayText));
    }
    $tourDateDisplay.val(dateText).change();
    $hiddenTourDate.val(createDateFormat(dateText));

    renderSixRows(dateText);
  });
});


/**
 * 寺院検索クエリパラメーター送信
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.form-search').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // フォーム値→クエリへ
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, val] of fd.entries()) {
        const v = (val ?? '').toString().trim();
        if (v !== '') params.append(key, v);
      }

      // plan-xxx上で、値が何も無ければ /search に飛ばす
      const isPlanPage = /^\/plan-[^/]+\/?$/.test(window.location.pathname);
      const hasAnyParam = params.toString() !== '';

      const url = new URL(form.action || window.location.pathname, window.location.origin);

      if (isPlanPage && !hasAnyParam) {
        url.pathname = '/search';
        url.search = '';
      } else {
        // 既存クエリは使わず、フォーム値だけで組み直す
        url.search = params.toString();
      }

      window.location.href = url.toString();
    });

    // 条件クリアボタン（完全リロード版）
    const clearBtn = form.querySelector('.btn-clear');

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();

        window.location.href = window.location.origin + '/search';
      });
    }
  });
});
